import { motion } from 'motion/react';

import styles from './Line.module.css';

export const Line = ({ line, delayLine = 0, y, padding }) => {
  const letters = line?.split('');

  if (!line) {
    return null;
  }

  return (
    <motion.div
      initial={{ y }}
      className={styles.lineWrapper}
      style={{ padding }}
    >
      {letters.map((l, idx, arr) => (
        <motion.div
          initial={{ opacity: 0, scale: 8, x: `-${arr.length - idx * 1.5}rem` }}
          animate={{ opacity: 1, scale: 1, x: 0 }}
          transition={{
            duration: 0.4,
            delay: 0.03 * (arr.length - idx) + 1 + delayLine,
          }}
          key={l + idx}
          className={`${styles.letter} ${l === ' ' ? styles.letterSpace : ''}`}
        >
          {l}
        </motion.div>
      ))}
    </motion.div>
  );
};
